import i18n from 'i18next';
import { object, string } from 'yup';

export const getSchema = (currentData) =>
  object().shape({
    ...(!currentData?.id ? { upload: string().required(i18n.t('common.fieldRequiredMessage')) } : {}),
    ...(currentData?.location && currentData?.id ? { location: string().required(i18n.t('common.fieldRequiredMessage')) } : {}),
    ...(!currentData?.location ? { jurisdiction: string().required(i18n.t('common.fieldRequiredMessage')) } : {}),
    vehicle: string().required(i18n.t('common.fieldRequiredMessage')),
    driver: string().required(i18n.t('common.fieldRequiredMessage')),
    cost: string().required(i18n.t('common.fieldRequiredMessage')),
    odometer: string().required(i18n.t('common.fieldRequiredMessage')),
    amount: string().required(i18n.t('common.fieldRequiredMessage')),
    date: string().required(i18n.t('common.fieldRequiredMessage')),
  });
